<script setup>
import { ref, computed } from "vue";

const nf = new Intl.NumberFormat("es-AR");

function toNumberFromArCurrency(v) {
  if (!v) return 0;
  const onlyDigits = String(v).replace(/[^\d]/g, "");
  return Number(onlyDigits || 0);
}
function formatArCurrency(v) {
  return v <= 0 ? "" : `$ ${nf.format(v)}`;
}

const garantiaInput = ref(null);

const garantia = computed(() => toNumberFromArCurrency(garantiaInput.value));

const credito = computed(() => garantia.value * 10);
const esIlimitado = computed(() => garantia.value >= 10000000);

const creditoLabel = computed(() =>
  esIlimitado.value ? "SIN TOPE" : `$ ${nf.format(credito.value)}`
);

function onInput(e) {
  const num = toNumberFromArCurrency(e.target.value);
  garantiaInput.value = formatArCurrency(num);
}
</script>

<template>
  <div class="card shadow-sm border-0">
    <div class="card-body">
      <h5 class="fw-bold mb-2">Calculadora de Crédito</h5>

      <p class="text-body-secondary mb-2">
        Para participar, tenés que depositar una garantía equivalente al
        <strong>10%</strong> del monto máximo de crédito que quieras para comprar.
      </p>
      <p class="text-body-secondary small mb-3">
        <em>
          Ejemplo: si ingresás como garantía $200.000 tu crédito para comprar será
          de $2.000.000.
        </em><br />
        <strong>A partir de $10.000.000, el crédito es ilimitado.</strong>
      </p>

      <div class="d-flex align-items-center gap-2 mb-2" v-if="garantiaInput">
        <span class="text-body-secondary">Crédito de compra:</span>
        <span
          class="badge bg-soft-green ms-3 pb-1 pt-1 fs-15 text-soft-green"
          style="font-size:0.95rem"
        >
          {{ creditoLabel }}
        </span>
      </div>

      <input
        class="form-control form-control-lg mb-3"
        inputmode="numeric"
        autocomplete="off"
        placeholder="Ingresá el valor de tu garantía"
        v-model="garantiaInput"
        @input="onInput"
      />
    </div>
  </div>
</template>

<style scoped>
.card { border-radius: 14px; }
.badge { font-weight: 700; }
</style>
